import React, {Component} from 'react';
import Rules from '../../utils/validation_rules';
import classnames from 'classnames';

export default class Select extends Component {
    static defaultProps = {
        label: '',
        placeholder: null,
        id: 'input',
        validators: [],
        errorMessage: '',
        value: '',
        required: false,
        className: '',
        onChange: () => {}
    }

    state = {
        isValid: true,
        is_success: false,
        error_message: null,
        show_errors: false,
        forced_error: false,
        value: ''
    }

    componentDidMount = () => {
        if (this.props.value) {
            this.setState({
                value: this.props.value
            });
        }
    }

    componentWillReceiveProps = (newProps) => {
        if (newProps.value && newProps.value !== this.props.value) {
            this.setState({
                value: newProps.value
            });
        }
    }

    validate = () => {
        let isValid = true;
        let message = this.props.errorMessage || '';
        let rules = this.props.validators;
        if (this.props.required) {
            rules = [
                Rules.isRequired,
                ...this.props.validators
            ];
        }

        rules.forEach(rule => {
            let {func, name, msg} = rule;
            let test = func.call(this);
            isValid = isValid && test;
            message = this.props[`${name}Msg`] || msg;
        });

        this.setState({
            isValid: isValid,
            error_message: message
        });

        return isValid;
    }

    getValue = () => {
        if (this.props.multiple) {
            let vals = [];
            let opts = this._input.getElementsByTagName('option');
            for (let i = 0; i < opts.length; i++) {
                if (opts[i].selected) {
                    vals.push(opts[i].value);
                }
            }
            return vals;
        }
        return this._input.value;
    }

    focus = () => {
        this._input.focus();
    }

    forceInvalidate = (message) => {
        this.setState({
            isValid: false,
            is_success: false,
            error_message: message || null,
            forced_error: true
        });
    }

    handleFocus = () => {
        this.setState({
            show_errors: true
        });
    }

    handleChange = (e) => {
        if (!this.state.isValid) {
            this.validate();
        }
        this.setState({
            value: this.getValue()
        });
        this.props.onChange(this.getValue());
    }

    handleBlur = () => {
        if (this.validate() && !this.state.forced_error) {
            this.setState({
                is_success: true
            });
        }
        this.setState({
            show_errors: false
        });
    }

    render = () => {
        let errors = null;
        let labelCss = classnames({
            'required': this.props.required || this.props.showRequired,
            'hidden': this.props.hidden
        });

        if (!this.state.isValid) {
            errors = (<div className="errors-list" style={{opacity: this.state.show_errors ? 1 : 0}}>
                <span>{this.state.error_message}</span>
            </div>);
        }

        return (
            <div className={classnames('input-wrapper', this.props.className)}>
                {this.props.label
                    ? <label htmlFor={this.props.id} className={labelCss}>{this.props.label}</label>
                    : null
                }
                <div className="input-box">
                    <div className={classnames('select-wrapper', {
                        'select-multiple': this.props.multiple
                    })}>
                        <select
                            className={classnames({
                                'input-collapse': this.props.collapse,
                                'success': this.state.isValid && this.state.is_success,
                                'error': !this.state.isValid
                            })}
                            ref={ref => (this._input = ref)}
                            value={this.props.multiple && !Array.isArray(this.state.value) ? [this.state.value] : this.state.value}
                            name={this.props.id}
                            id={this.props.id}
                            required={this.props.required}
                            multiple={this.props.multiple}
                            onFocus={this.handleFocus}
                            onBlur={this.handleBlur}
                            onChange={this.handleChange}>
                            {this.props.children}
                        </select>
                    </div>
                    {errors}
                    {this.props.multiple ? <div className="help-text">
                        <small><code>{window.navigator.platform.includes('Mac') ? 'command' : 'ctrl'} + click</code> to select multiple</small>
                    </div> : null}
                </div>
            </div>
        );
    }
}
